<form [formGroup]="formGroup">
  @for (group of entity.Groups | callback: filterGroups; track group.Key; let first = $first; let last = $last) {
    <div class="section" [ngClass]="{ border: !first, bottomMargin: !last }">
      <app-property-group
        [group]="group"
        (propertyChange)="onPropertyChange($event)"
        [formGroup]="formGroup"
        [isExpansionGroup]="hasExpansionGroups"
        [isExpanded]="isGroupExpanded(group)"
      ></app-property-group>
    </div>
  }
</form>
